<template>
    <div class="pane">
        <!-- 标题 完稿文件-->
        <div class="title-box">
            <h2 class="title">完稿文件</h2>
        </div>

        <div class="model-box">
            <div class="item-box all">
                <div class="label">文件上传空间</div>
                <div class="value">{{dataSource.storageFolderName}}</div>
            </div>
            <div class="item-box all">
                <div class="label"><span style="color: #ff4949;margin-right: 4px;" >*</span>上传文件</div>
                <!-- 当status>2时肯定有文件 -->
                <div class="file-list" v-if='dataSource.status > 2'>
                    <div v-if="beforeFileDetail.length >0">
                        <div class="value-box" v-for='item of beforeFileDetail' :key="item.id">
                            <!-- <svg-icon icon-class="xlsx" class="icon" /> -->
                            <div :style="{'background-image': 'url(' + item.thumbnailImageUrl + ')'}" class="thumbnailImageClass" @click="downloadUrlFun(item.id)"></div>

                            <span class="title" @click='rowClick(item)'>{{item.fileName}}</span>
                            
                            <el-button type="text" style="color:#3a89ff;padding:0 10px;line-height:20px" @click="downloadUrlFun(item.id)">下载</el-button>
                        </div>
                    </div>
                </div>
                <!-- 当为甲方时 -->
                <div v-else-if="accessPoint['mineuser']">
                        待乙方上传
                </div>
                <!-- 当为乙方时 -->
                <el-form v-else-if="accessPoint['outuser']" ref="uploadForm" :rules="uploadRules" :model="uploadForm">
                    <el-form-item prop="fileList" >
                         <!-- <simple-uploader ref="exampleUploader" :isSource="fileChunkUploadUrl"  @onSuccess="handleSuccess" @onRemove="handleRemove" ></simple-uploader> -->
                        <advanced-simple-uploader :beforeFileList="beforeFileDetail" :isSource="fileChunkUploadUrl" ref="exampleUploader"  @onSuccess="handleSuccess" @onRemove="handleRemove" @onDelete="handleRemove" :disabled="dataSource.status !== 2 " @rowClick='rowClick'></advanced-simple-uploader>
                    </el-form-item>
                </el-form>
                
            </div>
        </div>
         <!-- 图片预览 -->
        <image-viewer v-if="showViewer" :show-viewer="showViewer" :on-close="closeViewer" :url-list="[bugUrl]" :list-data="detailsData" @download="downloadUrlFun(detailsData.id)" ></image-viewer>


    </div>
</template>

<script>
import SimpleUploader from '../../../materialCenter/components/simpleUploader.vue'
import advancedSimpleUploader from '../advancedSimpleUploader.vue'
import {outsource_saveCompleteFile} from '@File~/api/outsourcing'
import ImageViewer from '../ImageViewer'
import {fileType} from '@/utils'
import { apiUrl } from '@File~/api/env' 

export default {
    components:{SimpleUploader,advancedSimpleUploader,ImageViewer},
    inject:['reload'],
    props:{
        dataSource:{
            type:Object,
            default:()=>{
                return null
            }
        }
    },
    data() {
        return { 
      fileChunkUploadUrl:this.$store.getters.uploadUrl,//apiUrl.fileUrl+"/api/file/fileChunkUpload",
            bugUrl:'',
            showViewer:false,
            detailsData:{},
            accessPoint: this.$store.getters.accessPoint, //权限点
            beforeFileDetail:[],
            fileList:[],
            uploadForm:{
                fileList:[]
            },
            uploadRules:{
                fileList: [{ required: true, message: '请上传文件', trigger: 'required' }]
            },

        }
    },
    created(){
    
        this.beforeFileDetail = this.dataSource.completeFileDetail?JSON.parse(this.dataSource.completeFileDetail):[]
        this.beforeFileDetail.map((item)=>{
                            item.fileId = item.id;
                            item.name = item.fileName;
                            item.relativePath = item.fileName;
                            item.size = item.fileSize;
                            item.fileType = item.fileContentType;
                        })
        this.fileList = this.beforeFileDetail;
    },
    // computed:{
    //     'uploadForm.fileList'(){
    //         return this.fileList
    //     }
    // },
    watch:{
        fileList(newVal){
            this.uploadForm.fileList = newVal;
        }
    },

    methods:{
        isFileType(type){
          return fileType(type);
        },
         // 关闭图片预览
        closeViewer() {
            // console.log('关闭预览===')
            this.showViewer = false
            this.bugUrl = ''
            this.listData = {}
        },
        rowClick(data){
            if(this.isFileType(data.suffixType) === 'picture' && data.loadFileBinaryUrl) { // 图片 显示大图
                this.bugUrl = data.loadFileBinaryUrl
            }else {// 视频、其它
                this.bugUrl = data.thumbnailImageUrl
            }
            this.detailsData = data
            this.showViewer = true;
        },
        
        //保存完稿文件
        sureUploadFun(noticeType,saveOrSure){
            //处理文件id
           this.$refs.uploadForm.validate((valid)=>{
               if(valid){
                    let tempArr = []
                    this.fileList.map((item)=>{
                        tempArr.push(item.fileId)
                    })

                    let data = {
                        id:this.dataSource.id,
                        userId:this.$store.state.user.userId,
                        completeFile:tempArr.join(','),
                        status:saveOrSure?3:2,//sureUploadFun:0保存 1确认
                        noticeType:noticeType
                    }
                    outsource_saveCompleteFile(data).then(response => {
                        if(response.code == 1) {
                            this.reload()
                            this.$message({
                                        message: "操作成功",
                                        type: "success"
                                    });
                        }
                    })

               }

           })
            
        },
         downloadUrlFun(id){
            var form = document.createElement('form')
            document.body.appendChild(form)
            form.setAttribute('style','display:none');
            form.setAttribute('method','post');
            form.setAttribute('action',this.$store.getters.downloadUrl);//下载文件的请求路径
            
            // 创建表单里 input 元素
            var tempInput = document.createElement("input");
            tempInput.type = "hidden";
            tempInput.name = 'fileId';
            tempInput.value = id;
            form.appendChild(tempInput);

            var tempInput2 = document.createElement("input");
            tempInput2.type = "hidden";
            tempInput2.name = 'userId';
            tempInput2.value = this.$store.getters.userId;
            form.appendChild(tempInput2);

            form.submit()
            document.body.removeChild(form)
        },
        // 上传成功
        handleSuccess(file, fileList) {
            this.fileList = fileList;
            this.$nextTick(()=>{
                this.$refs.uploadForm.validate()
            })
            // console.log(file, fileList)
        },

        // 删除已上传
        handleRemove(fileList,item) {
            this.fileList = fileList;
        }
    }
}
</script>

<style lang="scss" scoped>
.title{
    cursor: pointer;
    margin-left: 9px;
}

.thumbnailImageClass{
    width: 25px;
    height: 25px;
    background-color: white;
    background-size: contain;
    background-repeat: no-repeat;
}

.requireClass::before{
    content: "*";
    color: #ff4949;
    margin-right: 4px;
}

</style>